/* =============================================================================
 * Skeleton — APS primitive (Track D)
 * Content-shaped loading placeholder (replaces the ~55 spinner sites). Uses the
 * shared `aps-shimmer` keyframe from styles/globals.css. Prefer this over a
 * centered spinner for any data surface — it is the biggest perceived-perf win.
 * ========================================================================== */
import React from 'react';
import { radius } from '../../styles/tokens';

export type SkeletonVariant = 'line' | 'circle' | 'rect';

export interface SkeletonProps {
  variant?: SkeletonVariant;
  width?: number | string;
  height?: number | string;
  radiusPx?: number;
  style?: React.CSSProperties;
  'aria-label'?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({
  variant = 'line',
  width,
  height,
  radiusPx,
  style,
  ...aria
}) => {
  const w = width ?? (variant === 'circle' ? 40 : '100%');
  const h = height ?? (variant === 'circle' ? 40 : variant === 'line' ? 12 : 80);
  const r =
    radiusPx ?? (variant === 'circle' ? radius.pill : variant === 'line' ? 6 : radius.lg);
  return (
    <span
      role="status"
      aria-busy="true"
      aria-label={aria['aria-label'] ?? 'Loading'}
      style={{
        display: 'block',
        width: w,
        height: h,
        borderRadius: r,
        background:
          'linear-gradient(90deg, var(--aps-skeleton-base) 0px, var(--aps-skeleton-sheen) 160px, var(--aps-skeleton-base) 320px)',
        backgroundSize: '640px 100%',
        animation: 'aps-shimmer 1.3s infinite linear',
        ...style,
      }}
    />
  );
};

export default Skeleton;
